
<po-page-list #poPageListComponent
  p-title="Controle de Danos"
  [p-breadcrumb]="breadcrumb"
  [p-filter]="filterSettings"
>
  <div class="po-row">
      <po-button class="po-md-2" p-kind="secondary" p-label="Incluir" (p-click)="openModalNovoRegistro()" > </po-button>
      <po-button class="po-md-2" p-kind="secondary" p-label="Excel" (p-click)="gerarExcel()" > </po-button>
  </div>

  <po-table class="po-sm-12 po-md-12 po-lg-12"
    [p-height]="600"
    [p-hide-select-all]="true"
    [p-sort]="true"
    [p-striped]="true"
    [p-columns]="tabelaPrincipalColunas"
    [p-items]="tabelaPrincipalItens"
    p-spacing="small"
    [p-filter-type]="poSearchFilterMode"
    p-hide-table-search="false"
  ></po-table>

</po-page-list>

<po-modal #advancedFilterModal p-title="Filtros" [p-primary-action]="advancedFilterPrimaryAction">
  <form #f="ngForm">
    <po-datepicker
      class="po-md-6"
      name="DZ03DATA_DE"
      [(ngModel)]="tabelaPrincipalFiltro.dados.DZ03DATA_DE"
      p-format="dd/mm/yyyy"
      [p-iso-format]="formatExtended"
      p-label="Data de:"
    ></po-datepicker>
    <po-datepicker
      class="po-md-6"
      name="DZ03DATA_ATE"
      [(ngModel)]="tabelaPrincipalFiltro.dados.DZ03DATA_ATE"
      p-format="dd/mm/yyyy"
      [p-iso-format]="formatExtended"
      p-label="Data até:"
    ></po-datepicker>
    <po-input
      class="po-md-6"
      name="etiquetalote"
      [(ngModel)]="etiquetalote"
      p-label="Código Lote"
      (keyup.enter)="biparEtiqueta()"
    ></po-input>
  </form>
</po-modal>

<po-modal #dataRetornoModal p-title="Data Retorno" [p-primary-action]="salvarDataAction">
  <div class="po-row">
    <po-info class="po-sm-12 po-md-3 pomt-2 po-font-text-small" p-label="Codigo" [p-value]="retornoDano.CZ03COD"></po-info>
    <po-info class="po-sm-12 po-md-3 pomt-2 po-font-text-small" p-label="Quantidade Lote" [p-value]="loteRetorno.NB8QTDORI"></po-info>
  </div>

  <div class="po-row">
    <po-datepicker
      class="po-md-4"
      name="DZ03DTRET"
      [(ngModel)]="retornoDano.DZ03DTRET"
      p-format="dd/mm/yyyy"
      [p-iso-format]="formatExtended"
      p-label="Data"
    ></po-datepicker>
    <po-input
      class="po-md-4"
      [(ngModel)]="retornoDano.CZ03LTRET"
      p-label="Lote de Retorno"
      p-maxlength="10"
      (keyup.enter)="biparEtiquetaRetorno()"
      (p-blur)="biparEtiquetaRetorno()"
    ></po-input>
    <po-select
      class="po-md-4"
      name="select"
      [(ngModel)]="retornoDano.CZ03DESMONTE"
      p-label="Lote Desmontado"
      [p-options]="[
        {label: 'Nao', value: 'N' },
        {label: 'Sim', value: 'S' }
      ]"
    ></po-select>
  </div>

  <div class="po-row">
    <po-input
    class="po-md-12"
      name="CZ03OBSRT"
      [(ngModel)]="retornoDano.CZ03OBSRT"
      p-label="Observação de Retorno"
    ></po-input>
  </div>
</po-modal>

<po-modal #envLoteModal p-title="Alterar envio SOLIDA" [p-primary-action]="salvarEnvLotAction">

  <div class="po-row">
    <po-info class="po-sm-12 po-md-3 pomt-2 po-font-text-small" p-label="Codigo" [p-value]="retornoDano.CZ03COD"></po-info>
    <po-info class="po-sm-12 po-md-3 pomt-2 po-font-text-small" p-label="Quantidade Lote" [p-value]="loteRetorno.NB8QTDORI"></po-info>
  </div>

  <div class="po-row">
    <po-select
      class="po-md-12"
      name="CZ03ENVLOT"
      p-label="Enviado Lote para SOLIDA"
      [(ngModel)]="retornoDano.CZ03ENVLOT"
      [p-options]="envLoteLista"
    ></po-select>
  </div>
</po-modal>

<po-modal #criarRegistroModal p-title="Novo" [p-primary-action]="criarRegistroAction">
  <form #f="ngForm">
    <po-input
      class="po-md-6"
      name="etiquetalote"
      [(ngModel)]="etiquetalote"
      p-label="Lote"
      (keyup.enter)="redirectNovoCadastro()">
    ></po-input>
  </form>
</po-modal>
